var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3636 9.22727H17.4545V10.3182H16.3636V9.22727Z",
    fill: "#E0E0E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3.77273V20.1364H24V0.5H3.27273L0 3.77273ZM8.72621 3.77283V5.95461H15.2717V3.77283H8.72621ZM6.54545 7.04545L4.36364 9.22721V14.6818H7.63636V12.5H16.3636V14.6818H19.6364V9.22721L17.4545 7.04545H6.54545ZM7.63636 16.8637L9.81818 13.5909H14.1818L16.3636 16.8637H7.63636Z",
    fill: "#E0E0E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/Print.d33b5efe0f7641d918aa7b1b36d91d11.svg";
export { ForwardRef as ReactComponent };